import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AddDistrict from "./addDistrict";
import AddStatus from "./addStatus";
import AddUser from "./addUser";
import "./app.css";
import { secretKey } from "./data";
import Loading from "./loading.js";

const MySwal = withReactContent(Swal2);

const AdminPanel = (props) => {
  const [loading, setLoading] = useState(true);
  const [option, setOption] = useState(0);
  const [sources, setSources] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [users, setUsers] = useState([]);
  const [showAddUser, setShowAddUser] = useState(false);
  const [showAddDistrict, setShowAddDistrict] = useState(false);
  const [showEditUser, setShowEditUser] = useState(false);
  const [showEditDistrict, setShowEditDistrict] = useState(false);
  const [showAddStatus, setShowAddStatus] = useState(false);
  const [showEditStatus, setShowEditStatus] = useState(false);
  const [editUser, setEditUser] = useState([]);
  const [editDistrict, setEditDistrict] = useState([]);
  const [editStatus, setEditStatus] = useState([]);

  const closeAddUser = () => {
    setShowAddUser(false);
    getData();
  };

  const closeAddDistrict = () => {
    setShowAddDistrict(false);
    getData();
  };

  const closeEditUser = () => {
    setShowEditUser(false);
    getData();
  };

  const closeEditDistrict = () => {
    setShowEditDistrict(false);
    getData();
  };

  const closeAddStatus = () => {
    setShowAddStatus(false);
    getData();
  };

  const closeEditStatus = () => {
    setShowEditStatus(false);
    getData();
  };

  const fetchSources = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getLeadSources", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSources(data);
        fetchUsers();
      })
      .catch((error) => {});
  };

  const fetchUsers = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
        fetchCompanies();
      })
      .catch((error) => {});
  };

  const fetchCompanies = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getCompanies", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setCompanies(data);
        fetchDistricts();
      })
      .catch((error) => {});
  };

  const fetchDistricts = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getDistricts", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setDistricts(data);
        fetchStatuses();
      })
      .catch((error) => {});
  };

  const fetchStatuses = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getStatuses", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setStatuses(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchSources();
  };

  useEffect(() => {
    getData();
  }, []);

  const fetchDeletesource = async (id) => {
    var body = { id: id };

    await fetch("https://apisplit.ftpeople.pl/deleteSource", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Źródło",
          text: "usunięte",
        }).then(async (result) => {
          getData();
        });
      })
      .catch((error) => {});
  };

  const fetchAddSource = async (name) => {
    var body = { name: name };

    await fetch("https://apisplit.ftpeople.pl/addSource", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Źródło",
          text: "dodane",
        }).then(async (result) => {
          getData();
        });
      })
      .catch((error) => {});
  };

  const addSource = () => {
    MySwal.fire({
      title: "Dodaj",
      input: "text",
      inputLabel: "wartość",
      cancelButtonText: "Anuluj",
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return "Wpisz nazwe źródła";
        } else {
          fetchAddSource(value);
        }
      },
    });
  };

  const deleteSource = (e) => {
    fetchDeletesource(e.target.value);
  };

  const sourcesData = (
    <>
      <div style={{ marginTop: "5vh" }}>
        {sources.length === 0 ? (
          <>Brak zdefiniowanych źródeł w systemie</>
        ) : (
          <>
            <div style={{ textAlign: "left" }}>
              <span style={{ fontSize: ".6vw" }}>
                Źródła definiują dostawców leadów. Tylko źródła zdefiniowane w
                systemie są dostępne do importu z pliku oraz podczas ręcznego
                dodwania kontaktu.
              </span>
            </div>
            <table style={{ marginTop: "0vh" }} className="clients_table">
              <tr key={0}>
                <th style={{ width: "10%" }}>id</th>
                <th style={{ width: "80%" }}>nazwa</th>
                <th style={{ width: "10%" }}>akcja</th>
              </tr>
              {sources.map((el, index) => (
                <>
                  <tr>
                    <td>{el.id}</td>
                    <td>{el.name}</td>
                    <td>
                      {el.name === "Polecenie" || el.name === "CC" ? (
                        ""
                      ) : (
                        <button
                          className="loginButtonLogin"
                          id={"statusNote"}
                          value={el.id}
                          style={{
                            margin: "0",
                            backgroundColor: "navy",
                            borderColor: "navy",
                            width: "45%",
                            fontSize: ".6vw",
                            padding: "5px 5px",
                          }}
                          onClick={deleteSource}
                        >
                          usuń
                        </button>
                      )}
                    </td>
                  </tr>
                </>
              ))}
            </table>
          </>
        )}
      </div>
    </>
  );

  const fetchDeleteCompany = async (id) => {
    var body = { id: id };

    await fetch("https://apisplit.ftpeople.pl/deleteCompany", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Dział",
          text: "usunięty",
        }).then(async (result) => {
          getData();
        });
      })
      .catch((error) => {});
  };

  const fetchDeleteDistrict = async (id) => {
    var body = { id: id };

    await fetch("https://apisplit.ftpeople.pl/deleteDistrict", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Oddział",
          text: "usunięty",
        }).then(async (result) => {
          getData();
        });
      })
      .catch((error) => {});
  };

  const fetchAddCompany = async (name) => {
    var body = { name: name };

    await fetch("https://apisplit.ftpeople.pl/addCompany", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Dział",
          text: "dodany",
        }).then(async (result) => {
          getData();
        });
      })
      .catch((error) => {});
  };

  const addCompany = () => {
    MySwal.fire({
      title: "Dodaj",
      input: "text",
      inputLabel: "wartość",
      cancelButtonText: "Anuluj",
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return "Wpisz nazwe działu";
        } else {
          fetchAddCompany(value);
        }
      },
    });
  };

  const addDistrict = () => {
    setShowAddDistrict(true);
  };

  const deleteCompany = (e) => {
    fetchDeleteCompany(e.target.value);
  };

  const deleteDistrict = (e) => {
    fetchDeleteDistrict(e.target.value);
  };

  const companiesData = (
    <>
      <div style={{ marginTop: "5vh" }}>
        {companies.length === 0 ? (
          <>Brak zdefiniowanych działów w systemie</>
        ) : (
          <>
            <div style={{ textAlign: "left" }}>
              <span style={{ fontSize: ".6vw" }}>
                Działy definiują rodzaj projektowanych leadów.
              </span>
            </div>
            <table style={{ marginTop: "0vh" }} className="clients_table">
              <tr key={0}>
                <th style={{ width: "10%" }}>id</th>
                <th style={{ width: "80%" }}>nazwa</th>
                <th style={{ width: "10%" }}>akcja</th>
              </tr>
              {companies.map((el, index) => (
                <>
                  <tr>
                    <td>{el.id}</td>
                    <td>{el.name}</td>
                    <td>
                      <button
                        className="loginButtonLogin"
                        id={"statusNote"}
                        value={el.id}
                        style={{
                          margin: "0",
                          backgroundColor: "navy",
                          borderColor: "navy",
                          width: "45%",
                          fontSize: ".6vw",
                          padding: "5px 5px",
                        }}
                        onClick={deleteCompany}
                      >
                        usuń
                      </button>
                    </td>
                  </tr>
                </>
              ))}
            </table>
          </>
        )}
      </div>
    </>
  );

  const getSumCompany = (companyName) => {
    var int = 0;
    districts.map((district) => {
      JSON.parse(district.companies).map((el) => {
        if (el.name === companyName) {
          int = +int + +el.per;
        }
      });
    });
    return int;
  };

  const districtData = (
    <>
      <div style={{ marginTop: "5vh" }}>
        {districts.length === 0 ? (
          <>Brak zdefiniowanych działów w systemie</>
        ) : (
          <>
            <div style={{ textAlign: "left" }}>
              <span style={{ fontSize: ".6vw" }}>
                Oddziały definiują podział leadów.
              </span>
            </div>
            <table style={{ marginTop: "0vh" }} className="clients_table">
              <tr key={0}>
                <th style={{ width: "10%" }}>id</th>
                <th style={{ width: "80%" }}>nazwa</th>
                <th style={{ width: "80%" }}>udziały w leadach</th>
                <th style={{ width: "10%" }}>akcja</th>
              </tr>
              {districts.map((el, index) => (
                <>
                  <tr>
                    <td>{el.id}</td>
                    <td>{el.name}</td>
                    <td>
                      {JSON.parse(el.companies).map((el) => (
                        <p style={{ margin: "5px" }}>
                          {el.name} {el.per}%
                        </p>
                      ))}
                    </td>
                    <td>
                      <button
                        className="loginButtonLogin"
                        id={"statusNote"}
                        value={el.id}
                        style={{
                          margin: "0",
                          backgroundColor: "navy",
                          borderColor: "navy",
                          width: "45%",
                          fontSize: ".6vw",
                          padding: "5px 5px",
                        }}
                        onClick={(e) => {
                          setEditDistrict(
                            districts.filter(
                              (el) => +el.id === +e.target.value
                            )[0]
                          );
                          setShowEditDistrict(true);
                        }}
                      >
                        edytuj
                      </button>
                    </td>
                  </tr>
                </>
              ))}
            </table>
            <div style={{ textAlign: "left" }}>
              <p>Podusmowanie działów</p>
              <table
                style={{ marginTop: "0vh", width: "30%", textAlign: "left" }}
                className="clients_table"
              >
                <tr key={0}>
                  <th style={{ width: "10%" }}>id</th>
                  <th style={{ width: "40%" }}>nazwa</th>
                  <th style={{ width: "50%" }}>rozdane udziały</th>
                </tr>
                {companies.map((company, index) => (
                  <tr>
                    <td style={{ textAlign: "left" }}>{index + 1}</td>
                    <td style={{ textAlign: "left" }}>{company.name}</td>
                    <td style={{ textAlign: "left", paddingLeft: "15px" }}>
                      {getSumCompany(company.name)}%
                    </td>
                  </tr>
                ))}
              </table>
            </div>
          </>
        )}
      </div>
    </>
  );

  const handleEditUser = (e) => {
    setEditUser(users.filter((user) => +user.id === +e.target.value)[0]);
    setShowEditUser(true);
  };

  const usersData = (
    <>
      <div style={{ marginTop: "5vh" }}>
        {users.length === 0 ? (
          <>Brak zdefiniowanych użytkowników w systemie</>
        ) : (
          <>
            <div style={{ textAlign: "left" }}>
              <span style={{ fontSize: ".6vw" }}>
                Użytkownicy podzieleni są ze względu na role: administratorzy -
                mają dostęp do wszystkich funkcji oraz danych w systemie,
                użytkownicy - widzą ograniczony zakres danych (tylko przypisane
                sobie leady [oraz ich zasoby] oraz zadania wygenerowane "na
                siebie" [wraz z możliwością ich edycji], bądź w wersji read-only
                przypisane do innych użytkowników dla własnych leadów.
              </span>
            </div>
            <table style={{ marginTop: "0vh" }} className="clients_table">
              <tr key={0}>
                <th style={{ width: "20%" }}>nazwa</th>
                <th style={{ width: "10%" }}>adres e-mail</th>
                <th style={{ width: "10%" }}>numer telefonu</th>
                <th style={{ width: "10%" }}>oddział</th>
                <th style={{ width: "20%" }}>źródła</th>
                <th style={{ width: "20%" }}>akcja</th>
              </tr>
              {users.map((el, index) => (
                <>
                  <tr>
                    <td>{el.name}</td>
                    <td>{el.mail}</td>
                    <td>{el.phone}</td>
                    <td>{el.companies}</td>
                    <td>{el.brands}</td>
                    <td>
                      <button
                        className="loginButtonLogin"
                        id={"statusNote"}
                        value={el.id}
                        style={{
                          margin: "0",
                          backgroundColor: "navy",
                          borderColor: "navy",
                          width: "45%",
                          fontSize: ".6vw",
                          padding: "5px 5px",
                          marginLeft: "10px",
                        }}
                        onClick={handleEditUser}
                      >
                        edytuj
                      </button>
                    </td>
                  </tr>
                </>
              ))}
            </table>
          </>
        )}
      </div>
    </>
  );

  const handleEditStatus = (e) => {
    setEditStatus(
      statuses.filter((status) => +status.id === +e.target.value)[0]
    );
    setShowEditStatus(true);
  };

  const statusData = (
    <>
      <div style={{ marginTop: "5vh" }}>
        {users.length === 0 ? (
          <>Brak zdefiniowanych użytkowników w systemie</>
        ) : (
          <>
            <div style={{ textAlign: "left" }}>
              <span style={{ fontSize: ".6vw" }}>
                Statusy określają poziom zaawansowania obróbki leada. Wybrany
                kolor będzie reprezentował status na liście leadów.
              </span>
            </div>
            <table style={{ marginTop: "0vh" }} className="clients_table">
              <tr key={0}>
                <th style={{ width: "20%" }}>nazwa</th>
                <th style={{ width: "10%" }}>kolor</th>
                <th style={{ width: "10%" }}>pozycja - sortowanie</th>
                <th style={{ width: "20%" }}>akcja</th>
              </tr>
              {statuses.map((el, index) => (
                <>
                  <tr>
                    <td>{el.name}</td>
                    <td style={{ backgroundColor: el.color }}></td>
                    <td>{el.poz}</td>
                    <td>
                      <button
                        className="loginButtonLogin"
                        id={"statusNote"}
                        value={el.id}
                        style={{
                          margin: "0",
                          backgroundColor: "navy",
                          borderColor: "navy",
                          width: "45%",
                          fontSize: ".6vw",
                          padding: "5px 5px",
                          marginLeft: "10px",
                        }}
                        onClick={handleEditStatus}
                      >
                        edytuj
                      </button>
                    </td>
                  </tr>
                </>
              ))}
            </table>
          </>
        )}
      </div>
    </>
  );

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          {showEditUser ? (
            <AddUser
              user={props.user}
              userEdit={editUser}
              mode={"edit"}
              close={closeEditUser}
              sources={sources}
              companies={companies}
              statuses={statuses}
              districts={districts}
            />
          ) : (
            ""
          )}

          {showEditDistrict ? (
            <AddDistrict
              user={props.user}
              districtEdit={editDistrict}
              mode={"edit"}
              close={closeEditDistrict}
              companies={companies}
            />
          ) : (
            ""
          )}
          {showAddStatus ? (
            <AddStatus
              user={props.user}
              mode={"add"}
              close={closeAddStatus}
              sources={sources}
              companies={companies}
            />
          ) : (
            ""
          )}
          {showEditStatus ? (
            <AddStatus
              user={props.user}
              statusEdit={editStatus}
              mode={"edit"}
              close={closeEditStatus}
              sources={sources}
              companies={companies}
            />
          ) : (
            ""
          )}
          {showAddUser ? (
            <AddUser
              user={props.user}
              mode={"add"}
              close={closeAddUser}
              sources={sources}
              companies={companies}
              districts={districts}
            />
          ) : (
            ""
          )}
          {showAddDistrict ? (
            <AddDistrict
              user={props.user}
              mode={"add"}
              close={closeAddDistrict}
              companies={companies}
            />
          ) : (
            ""
          )}
          <div
            style={{
              paddingBottom: "3vh",
              minWidth: "79vw",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "left",
                gap: "1vw",
                alignItems: "self-end",
                position: "sticky",
                flexWrap: "wrap",
                top: "0",
                zIndex: "1",
                padding: "5px 5px",
                backgroundColor: "white",
                paddingLeft: "1vw",
                width: "100%",
                paddingBottom: "10px",
              }}
            >
              <button
                className="loginButtonLogin"
                value="yes"
                style={{ margin: "0", width: "15%" }}
                onClick={() => setOption(0)}
              >
                ŹRÓDŁA
              </button>
              <button
                className="loginButtonLogin"
                value="yes"
                style={{
                  margin: "0",
                  width: "15%",
                  backgroundColor: "cyan",
                  borderColor: "cyan",
                  color: "black",
                }}
                onClick={() => setOption(4)}
              >
                ODDZIAŁY
              </button>
              <button
                className="loginButtonLogin"
                value="yes"
                style={{
                  margin: "0",
                  width: "15%",
                  backgroundColor: "navy",
                  borderColor: "navy",
                }}
                onClick={() => setOption(2)}
              >
                DZIAŁY
              </button>
              <button
                className="loginButtonLogin"
                value="yes"
                style={{
                  margin: "0",
                  width: "15%",
                  backgroundColor: "green",
                  borderColor: "green",
                }}
                onClick={() => setOption(1)}
              >
                UŻYTKOWNICY
              </button>
              <button
                className="loginButtonLogin"
                value="yes"
                style={{
                  margin: "0",
                  width: "15%",
                  backgroundColor: "red",
                  borderColor: "red",
                }}
                onClick={() => setOption(3)}
              >
                STATUSY
              </button>
            </div>
            <hr
              style={{
                borderWidth: "1px",
                borderColor: "lightgray",
                opacity: ".3",
                backgroundColor: "lightgray",
                zIndex: "-1",
                position: "relative",
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "left",
                gap: "1vw",
                marginTop: "1vh",
              }}
            >
              {option === 0 ? (
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    width: "20%",
                    backgroundColor: "lightgray",
                    borderColor: "lightgray",
                    color: "gray",
                  }}
                  onClick={addSource}
                >
                  DODAJ ŹRÓDŁO
                </button>
              ) : (
                ""
              )}
              {option === 1 ? (
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    width: "20%",
                    backgroundColor: "lightgray",
                    borderColor: "lightgray",
                    color: "gray",
                  }}
                  onClick={() => setShowAddUser(true)}
                >
                  DODAJ UŻYTKOWNIKA
                </button>
              ) : (
                ""
              )}
              {option === 2 ? (
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    width: "20%",
                    backgroundColor: "lightgray",
                    borderColor: "lightgray",
                    color: "gray",
                  }}
                  onClick={addCompany}
                >
                  DODAJ DZIAŁ
                </button>
              ) : (
                ""
              )}
              {option === 4 ? (
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    width: "20%",
                    backgroundColor: "lightgray",
                    borderColor: "lightgray",
                    color: "gray",
                  }}
                  onClick={addDistrict}
                >
                  DODAJ ODDZIAŁ
                </button>
              ) : (
                ""
              )}
              {option === 3 ? (
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    width: "20%",
                    backgroundColor: "lightgray",
                    borderColor: "lightgray",
                    color: "gray",
                  }}
                  onClick={() => setShowAddStatus(true)}
                >
                  DODAJ STATUS
                </button>
              ) : (
                ""
              )}
            </div>
            <div style={{ paddingLeft: "1vw" }}>
              {+option === 0 ? <>{sourcesData}</> : ""}
              {+option === 1 ? <>{usersData}</> : ""}
              {+option === 2 ? <>{companiesData}</> : ""}
              {+option === 3 ? <>{statusData}</> : ""}
              {+option === 4 ? <>{districtData}</> : ""}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AdminPanel;
